import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Box, Typography } from "@mui/material";
import PointBox from '../components/PointBox';
import ReadyStart from '../screens/ReadyStart';
import Step from "../components/Step";

import cashInHandsImage from "../assets/images/cash-in-hand.svg";
import IncomeStatsImage from "../assets/images/income-stats-image.svg";

import DollarIcon from "../assets/icons/dollar-icon.svg";
import PhoneCheckIcon from "../assets/icons/phone-check.svg";
import DoubleCheckIcon from "../assets/icons/double-check.svg";
import DollarStarIcon from "../assets/icons/dollar-star.svg";


import ShieldIcon from '../assets/icons/shield-icon.svg';
import TimeRollIcon from '../assets/icons/time-roll.svg';
import ChargeStationIcon from '../assets/icons/charge-station.svg';

function HostPage() {
  return (
    <>
      {/* HEADER HERE */}
      <NavBar />

      {/* HERO SECTION */}
      <Box sx={{
        display: "flex",
        flexDirection: 'column',
        justifyContent: "space-between",
        gap: "2rem",
        width: "100%",
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
        paddingTop: { xs: '5rem', sm: "8rem" },
        height: '100vh',
        maxHeight: { xs: '100%', md: '150vw' },
      }}>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: 'space-between',
            textAlign: { md: "left" },
            gap: "3.5rem",
            padding: { xs: '3rem', sm: '4rem', md: '6.4rem', lg: '6.4rem' },
          }}
        >
          <Typography
            sx={{
              color: "toughGrey",
              fontSize: '1.6rem',
              fontWeight: 500,
              width: 'fit-content',
            }}
          >
            HOSTS
          </Typography>

          <Typography
            sx={{
              color: "white",
              fontSize: { xs: '4rem', sm: '5rem', md: '7.2rem' },
              fontWeight: 700,
              lineHeight: { xs: '4rem', sm: '5rem', md: '6rem' },
              maxWidth: '25ch',
            }}
          >
            Earn passively with your EV charger.
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: '100%',
            maxHeight: 'calc(60vh - 5rem)',
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              right: 0,
              left: 0,
              zIndex: 0,
              opacity: 1,
              backgroundImage: `url(${require('../assets/images/host-hero-bg.png')})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'top',
              backgroundOrigin: 'top',

            }}
          ></Box>
        </Box>
      </Box>

      {/* DRIVERS PAGE CONTENT HERE */}
      <Box sx={{
        padding: "6.4rem",
        px: { xs: '2rem', sm: '2rem', md: '6.4rem', lg: '6.4rem' },
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
      }}>

        {/* TRANSFORM NOTE SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              Transform your EV charger into a profit powerhouse.
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box sx={{ listStyle: "none", color: "paleWhite" }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  Turn your existing EV charger into a steady income stream. With SplitEV,
                  listing your Level 2 charger on our network is a simple and secure way to tap into the booming electric vehicle market.
                  Let your charger work for you—boosting your property’s value while generating extra revenue.
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { sm: "40rem", md: "65rem" },
              height: { xs: "40rem", sm: "65rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/cash-in-hand.svg').default})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>
        </Box>

        {/* EARN MORE NOTE SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "100%",
          maxWidth: "128rem",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>
          <Box
            data-aos="flip-down"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            sx={{
              position: "relative",
              width: { sm: "40rem", md: "65rem" },
              height: { xs: "40rem", sm: "65rem" },
              borderRadius: "2.5rem",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${require('../assets/images/income-stats-image.svg').default})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                backgroundOrigin: 'top',
              }}
            ></Box>
          </Box>


          <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' },
                marginBottom: '1.6rem',
              }}
            >
              Earn more, worry less.
            </Typography>

            <Box
              sx={{
                listStyle: "disc",
                color: "paleWhite",
                ml: "1.8rem",
                display: "flex",
                flexDirection: "column",
                gap: "1.4rem"
              }}
              component="ol">
              <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                Automatic payouts → Your earnings are deposited monthly, no chasing or paperwork.
              </Box>

              <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                Seamless reservations → Drivers book through the app; you set availability and relax.
              </Box>

              <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                Fair pricing → Earn more during peak hours and even when cars sit idle.
              </Box>

              <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                Solar bonus → Turn sunshine into extra profit with higher payouts for clean energy.
              </Box>

              <Box sx={{ fontSize: "1.8rem", fontWeight: "400" }} component="li">
                Community impact → Every session makes EV driving easier and your neighborhood greener.
              </Box>
            </Box>
          </Box>
        </Box>

        {/* KEY FEATURES SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '5rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              Our key features for your peace of mind.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointBox
                image={ShieldIcon}
                title="Verified Users Only"
                text='Every driver is thoroughly vetted before they can access your charger.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={TimeRollIcon}
                title="Real-Time Monitoring"
                text='Keep track of every charging session at your convenience.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={ChargeStationIcon}
                title="Flexible Scheduling"
                text='Set the availability of your charger to match your property’s needs.'>
              </PointBox>
            </Box>
          </Box>
        </Box>

        {/* WHAT TO EARN NOTE SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', lg: "row" },
          gap: { xs: "2rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "fit-content",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontWeight: 700,
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              What you could earn.
            </Typography>

            <Box sx={{ fontSize: "1.6rem", fontWeight: "400", maxWidth: '60ch', textAlign: "left" }}>
              Your charger isn’t just hardware it’s an income stream waiting to happen. With SplitEV, the more drivers use your charger, the more you earn. And those earnings add up fast:
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "3rem",
              height: "fit-content"
            }}
          >
            <Typography sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch' }}>
              ⚡ Every charge counts. The more your station is used, the more you earn all while supporting clean energy and your community.
            </Typography>

            <Box sx={{
              display: "flex",
              flexDirection: { xs: 'column', sm: 'column', md: 'row' },
              gap: { xs: "3rem", sm: "10rem" },
              justifyItems: "space-around",
              alignItems: "left",
              width: "fit-content",
              my: { xs: '1rem', sm: '2rem' },
            }}>
              <Box>
                <Typography sx={{ fontSize: "1.6rem", fontWeight: "400" }}>
                  MODEST USAGE
                </Typography>

                <Typography
                  sx={{
                    color: { xs: "primary.main", md: "white" },
                    fontSize: { xs: '3.4rem', sm: '4.6rem' },
                    fontWeight: 700,
                    lineHeight: { xs: '5rem', sm: '5.7rem' },
                    maxWidth: '24ch',
                    textAlign: { xs: 'left' }
                  }}
                >
                  $1,050/
                </Typography>

                <Typography
                  sx={{
                    color: { xs: "primary.main", md: "white" },
                    fontSize: { xs: '3.4rem', sm: '4.6rem' },
                    fontWeight: 700,
                    lineHeight: { xs: '2rem', sm: '2rem' },
                    maxWidth: '24ch',
                    textAlign: { xs: 'left' }
                  }}
                >
                  month
                </Typography>

                <Typography sx={{ fontSize: "1.6rem", fontWeight: "400", marginY: '2.5rem' }}>
                  or up to $12,600/year
                </Typography>
              </Box>

              <Box>
                <Typography sx={{ fontSize: "1.6rem", fontWeight: "400" }}>
                  HIGH USAGE
                </Typography>

                <Typography
                  sx={{
                    color: { xs: "primary.main", md: "white" },
                    fontSize: { xs: '3.4rem', sm: '4.6rem' },
                    fontWeight: 700,
                    lineHeight: { xs: '5rem', sm: '5.7rem' },
                    maxWidth: '24ch',
                    textAlign: { xs: 'left' }
                  }}
                >
                  $2,100+/
                </Typography>

                <Typography
                  sx={{
                    color: { xs: "primary.main", md: "white" },
                    fontSize: { xs: '3.4rem', sm: '4.6rem' },
                    fontWeight: 700,
                    lineHeight: { xs: '2rem', sm: '2rem' },
                    maxWidth: '24ch',
                    textAlign: { xs: 'left' }
                  }}
                >
                  month
                </Typography>

                <Typography sx={{ fontSize: "1.6rem", fontWeight: "400", marginY: '2.5rem' }}>
                  or up to $25,200/year
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box sx={{ listStyle: "none", color: "paleWhite" }} component="ol">
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '65ch', }} component="li">
                  These estimates may vary based on local demand, the types of charging sessions, and session duration. In short, as usage increases, so does your income!
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* WHY LIST SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '5rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              Why list your charger on SplitEV?
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointBox
                image={DollarIcon}
                title="Steady extra incomey"
                text='Turn your underused charger into a consistent revenue generator.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={PhoneCheckIcon}
                title="Quick and easy listing"
                text='Get started in minutes—simply list your charger on our network with no complicated installations required.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={DoubleCheckIcon}
                title="Total control"
                text='Manage your charger’s schedule and monitor usage with our user-friendly tools.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={DollarStarIcon}
                title="Boost your property value"
                text='Offering a modern, sustainable amenity makes your property more attractive to tenants and visitors alike.'>
              </PointBox>
            </Box>
          </Box>
        </Box>

        {/* HOW IT WORKS SECTION */}
        <Box sx={{
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Typography
            sx={{
              color: "white",
              fontWeight: 700,
              margin: "4rem auto",
              fontSize: { xs: '3.4rem', sm: '4.6rem' },
              lineHeight: { xs: '4rem', sm: '5.7rem' },
              textAlign: "center"
            }}
          >
            How it Works
          </Typography>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              my: "4rem auto",
              maxWidth: "55ch",
              width: "95%",
              display: "flex",
              flexDirection: "column",
              gap: "2rem"
            }}
          >
            <Step
              position="1"
              title="Download the App"
              text=" Get the SplitEV app on your phone. It’s your gateway to a seamless 
                          charging experience across North America."
            />

            <Step
              position="2"
              title=" List your property in minutes"
              text="Pick the subscription level (Basic or Premium) that suits your driving needs. 
                No haggling or hidden charges—just straightforward pricing."
            />

            <Step
              position="3"
              title="Earn automatically with every charging session"
              text="
                Pick the subscription level (Basic or Premium) that suits your driving needs. 
                No haggling or hidden charges—just straightforward pricing.
              "
            />
          </Box>

        </Box>

      </Box >

      {/* FOOTER SECTION */}
      <ReadyStart phrase="List your charger now" subtitle="Join a growing community of hosts who are turning their chargers into profit powerhouses. With SplitEV, every charge brings you closer to a secure, profitable future while you maintain full control and peace of mind."></ReadyStart>
      < Footer />
    </>
  );
}

export default HostPage;